import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精彩预告</h2>
            <p className="mt-2 text-sm text-foreground-500">热门推荐，先睹为快</p>
          </div>
          <a href="#cards" className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <article key={item.id} className="group cursor-pointer">
              <div className="relative rounded-lg overflow-hidden aspect-video bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentNode as HTMLElement)?.classList.add('bg-background-200');
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-black/60 text-white whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center cursor-pointer">
                    <i className="ri-play-fill text-xl text-white ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="mt-3">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}